export const translations = {
	'Dynamic data': {},
	'Hide header': { no: 'Skjul tittel' },
};
